/*
 * Copyright    :Copyright© 2022 AOMEI
 * Abstract     :
 * Date         :2024-03-05 17:33:51
 * Author       :
 * LastEditors  :chenjia
 * LastEditTime :2025-04-10 15:21:52
 * FilePath     :\AV-COM-user-backend\src\router\personal.js
 * RevisionHistory:
 */
import i18n from "@/lang/index";
export const personalRouter = {
    path: "/",
    component: () => import("@/layout/BasisLayout"), //路由懒加载
    name: "home",
    redirect: "/userinfo",
    children: [
        {
            path: "/userinfo",
            name: "userinfo",
            component: () => import("@/views/userInfo/index"),
            meta: {
                name: i18n.t("menu.account"),
                icon: "info",
                menue: true,
                menuTxt: i18n.t("menu.account"),
            },
        },
        {
            path: "/device",
            name: "PersonalDevice",
            component: () => import("@/views/device/index"),
            meta: {
                name: i18n.t("menu.personalDevice"),
                icon: "personal",
                menue: true,
                menuTxt: i18n.t("menu.personalDevice"),
            },
        },
    ],
};
